import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../common/SvgIcon';
import InternetBankingActions from '../../actions/InternetBankingActions';
import Modal from '../../components/common/modals/PatternLibModalComponent';
import UserManagementStore from '../../stores/UserManagementStore';
import { LetsChatDecisionModal } from './LetsChatDecisionModal';
import { storageAvailable } from '../../utils/LocalStorageUtils';

const slab = 'c-slab';
const labelId = 'secure-message';
const iconSize = '64px';
const dontShowLetsChatModalAgain = 'VM_HideLetsChatModal';
const TRUE = '1';

/**
 * @todo
 * This component has several accessibility issues caused by the intention
 * to create a clickable button/link out of the wrapping `<div>`
 * The anchor tags inside aren't intended to recieve interaction events, they've
 * just been made anchors so that they visually appear like links.
 *
 * None of this really helps unsighted customers, or customers who are using a
 * keyboard to navigate around, as you won't be able to use your keyboard
 * to "click" the `<div>` due to a lack of keyboard handlers.
 *
 * Solution: refactor the div into an anchor, and use css to deliver
 * the appropriate styling accordingly.
 */
class SecureMessage extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleLetsChat = this.handleLetsChat.bind(this);
    this.setLocalStorageSecureMessageIBUserPreference =
      this.setLocalStorageSecureMessageIBUserPreference.bind(this);
    this.continueWithSecureMessaging =
      this.continueWithSecureMessaging.bind(this);
    this.handleDontShowAgainOnChange =
      this.handleDontShowAgainOnChange.bind(this);
    this.secureMessagePopupClose = this.secureMessagePopupClose.bind(this);

    this.state = {
      showModal: false,
      dontShowAgain: false,
    };
  }

  handleClick() {
    const localStorageDontShowAgainPref = storageAvailable('localStorage')
      ? window.localStorage.getItem(dontShowLetsChatModalAgain) ?? false
      : false;
    const shouldShowLetsChatModal = localStorageDontShowAgainPref !== TRUE;
    if (!UserManagementStore.isBusinessUser() && shouldShowLetsChatModal)
      this.setState({ showModal: true });
    else InternetBankingActions.navigateToWebTask('WEB-SECURE-MESSAGE');
  }

  setLocalStorageSecureMessageIBUserPreference() {
    if (this.state.dontShowAgain && storageAvailable('localStorage')) {
      window.localStorage.setItem(dontShowLetsChatModalAgain, TRUE);
    }
  }

  handleLetsChat() {
    try {
      window.Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
    } catch (error) {
      window.dtrum?.reportError(error);
    }
    this.setLocalStorageSecureMessageIBUserPreference();
    this.setState({ showModal: false });
  }

  continueWithSecureMessaging() {
    this.setLocalStorageSecureMessageIBUserPreference();
    InternetBankingActions.navigateToWebTask('WEB-SECURE-MESSAGE');
  }

  handleDontShowAgainOnChange() {
    this.setState((state) => ({ dontShowAgain: !state.dontShowAgain }));
  }

  secureMessagePopupClose() {
    this.setLocalStorageSecureMessageIBUserPreference();
    this.setState({ showModal: false });
  }

  render() {
    const isValid = this.props.count > 0;
    return (
      <div
        role="link"
        className={`${slab} ${slab}--icon ${slab}--messages l-tile`}
        aria-labelledby={labelId}
        onClick={this.handleClick}
      >
        {this.state.showModal && (
          <Modal
            show={this.state.showModal}
            onHide={this.secureMessagePopupClose}
            bsSize={'medium'}
            modalHeading={this.props.content.letsChatModalTitle}
            modalBody={
              <LetsChatDecisionModal
                continueWithSecureMessaging={this.continueWithSecureMessaging}
                handleLetsChat={this.handleLetsChat}
                dontShowAgain={this.state.dontShowAgain}
                handleDontShowAgainOnChange={this.handleDontShowAgainOnChange}
                content={this.props.content}
              />
            }
            customClass={'c-modal'}
          />
        )}
        <div className={`l-tile`}>
          <div className={`${slab}__top-wrap`}>
            <div className={`${slab}__icon`} aria-hidden="true">
              <SvgIcon
                className={`${slab}__svg`}
                id="icon-envelope"
                width={iconSize}
                height={iconSize}
              />
              {isValid && (
                <span className={`${slab}__badge badge badge--message`}>
                  {this.props.count}
                </span>
              )}
            </div>
            <h3 id={labelId} className={`${slab}__title`}>
              {/** @todo This anchor should just be styled text instead. */}
              <a className={`${slab}__link`} href="javascript:void(0)">
                {isValid
                  ? `${this.props.content.youGot}${this.props.count}${
                      this.props.count === 1
                        ? this.props.content.oneSecureMessage
                        : this.props.content.newSecureMessages
                    }`
                  : this.props.content.secureMessages}
              </a>
            </h3>
          </div>
        </div>
      </div>
    );
  }
}

SecureMessage.propTypes = {
  content: PropTypes.object,
  count: PropTypes.number,
};

export { SecureMessage };
